"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _withThemeStyles = _interopRequireDefault(require("@concur/react-ui-theming/lib/utils/withThemeStyles"));
var _bind2 = _interopRequireDefault(require("classnames/bind"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _react = _interopRequireDefault(require("react"));
var _compose = _interopRequireDefault(require("../utils/compose"));
var _excluded = ["classNameMap"];
var _default = exports["default"] = function _default(styles) {
  return function (WrappedComponent) {
    var Component = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
      var classNameMap = _ref.classNameMap,
        props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
      var extraProps = {};
      if ((0, _keys["default"])(classNameMap || {}).length > 0) {
        extraProps.modularClassnames = (0, _bind["default"])(_bind2["default"]).call(_bind2["default"], classNameMap);
      } else {
        extraProps.modularClassnames = (0, _bind["default"])(_bind2["default"]).call(_bind2["default"], {});
      }
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, {
        ref: ref
      }, extraProps));
    });
    (0, _hoistNonReactStatics["default"])(Component, WrappedComponent);
    Component.displayName = WrappedComponent.displayName || WrappedComponent.name;
    Component.defaultProps = WrappedComponent.defaultProps;
    Component.propTypes = WrappedComponent.propTypes;
    return (0, _compose["default"])((0, _withThemeStyles["default"])(styles))(Component);
  };
};